/**
 * 方形化輸出的補邊底色，確保透明 PNG 不會出現黑底。
 *
 * 鏡射 `@theme` 的 `--color-paper` token（`libs/shared/ui-system/src/styles/globals.css`）。
 * canvas／Worker 讀不到 CSS `var()`，為固定色做 runtime `getComputedStyle` 屬過度設計，
 * 故直接內聯字面量；變更顏色時兩處需一起改。
 */
export const PHOTO_PADDING_BACKGROUND = '#FFFFFF';

/**
 * 取長邊為方形邊長，讓補邊後的圖片不會被縮小。
 *
 * @example
 * calcSquareDimension(300, 500) // 500
 * calcSquareDimension(800, 600) // 800
 */
export function calcSquareDimension(
  originalWidth: number,
  originalHeight: number,
): number {
  return Math.max(originalWidth, originalHeight);
}

/**
 * 算出上緣與左緣要補多少。下緣與右緣補的是剩餘的部分，總和為奇數時會多一像素。
 *
 * @example
 * // 原始 300×500，目標 500×500
 * calcPadding(500, 300, 500)
 * // { top: 0, left: 100 } — 左右各補 100px
 *
 * // 原始 800×600，目標 800×800
 * calcPadding(800, 800, 600)
 * // { top: 100, left: 0 } — 上下各補 100px
 */
export function calcPadding(
  squareDimension: number,
  originalWidth: number,
  originalHeight: number,
): { top: number; left: number } {
  const verticalPadding = squareDimension - originalHeight;
  const horizontalPadding = squareDimension - originalWidth;

  const top = Math.floor(verticalPadding / 2);
  const left = Math.floor(horizontalPadding / 2);

  return { top, left };
}
